import { IRootState } from '@/store'
import { IOrderReview } from '@/store/modules/common/interface/IOrderReview'
import { ActionTree, MutationTree } from 'vuex'
import { CommonActionType } from './action-type'
import { AugmentedCommonActionType } from './ICommonActions'
import { ICommonMutations } from './ICommonMutations'
import { IDropdownItems } from './interface/IDropdownItems'
import { CommonMutationType } from './mutation-type'
import {
  getOrderTransportTypesAPI,
  getShipmentPlacesAPI,
  getOrderStatusAPI,
  getStatusForCZ,
  getOrderStatusITAPI,
  getOrderDeliveryStatusITAPI
} from './services/common.api'
export interface ICommonState {
  orderReview: IOrderReview
  shipmentPlacesList: IDropdownItems[]
  orderTransportTypesList: IDropdownItems[]
  orderStatusList: IDropdownItems[],
  orderStatusCZ: IDropdownItems[],
  orderDeliveryStatusListIT: IDropdownItems[],
  orderStatusListIT: IDropdownItems[],
  loadingCount: number
  multipleTypeCustomer: boolean
}

const state = (): ICommonState => ({
  orderReview: {} as IOrderReview,
  shipmentPlacesList: [],
  orderTransportTypesList: [],
  orderStatusList: [],
  orderStatusCZ: [],
  orderDeliveryStatusListIT: [],
  orderStatusListIT: [],
  loadingCount: 0,
  multipleTypeCustomer: false

})

const getters = {
  getOrderReview (state: ICommonState) {
    return state.orderReview
  },
  getShipmentPlaces (state: ICommonState) {
    return state.shipmentPlacesList
  },
  getOrderTransportTypes (state: ICommonState) {
    return state.orderTransportTypesList
  },
  getOrderStatusCZ (state: ICommonState) {
    return state.orderStatusCZ
  },
  getOrderStatus (state: ICommonState) {
    return state.orderStatusList
  },
  isGlobalLoading (state: ICommonState): boolean {
    return state.loadingCount > 0
  },
  isMultiTypeCustomer (state: ICommonState): boolean {
    return state.multipleTypeCustomer
  }
}

const actions: ActionTree<ICommonState, IRootState> = {
  async [CommonActionType.FETCH_SHIPMENT_PLACES_LIST] ({ commit }: AugmentedCommonActionType) {
    try {
      const response = await getShipmentPlacesAPI()
      commit(CommonMutationType.SET_SHIPMENT_PLACES_LIST, response)
    } catch (error) {
      console.error(error)
    }
  },
  async [CommonActionType.FETCH_ORDER_STATUS_CZ] ({ commit }: AugmentedCommonActionType) {
    const response = await getStatusForCZ()
    let options = []
    options = response.map((ot: any) => {
      return {
        value: ot.id,
        label: ot.description
      }
    })
    commit(CommonMutationType.SET_ORDER_STATUS_CZ, options)
  },
  async [CommonActionType.FETCH_ORDER_TRANSPORT_TYPES_LIST] ({ commit }: AugmentedCommonActionType) {
    try {
      const response = await getOrderTransportTypesAPI()
      let options = []
      options = response?.orderTypesDetailsDto.map((ot: any) => {
        return {
          label: ot.orderTypeDescription,
          value: ot.orderType
        }
      })
      commit(CommonMutationType.SET_ORDER_TRANSPORT_TYPES_LIST, options)
    } catch (error) {
      console.error(error)
    }
  },
  async [CommonActionType.FETCH_ORDER_STATUS_LIST] ({ commit }: any, { language }: any) {
    try {
      const response = await getOrderStatusAPI()
      commit(CommonMutationType.SET_ORDER_STATUS_LIST, response[language])
    } catch (error) {
      console.error(error)
    }
  },

  async [CommonActionType.FETCH_ORDER_STATUS_LIST_IT] ({ commit }: any) {
    try {
      const response = await getOrderStatusITAPI()
      commit(CommonMutationType.SET_ORDER_STATUS_LIST_IT, response)
    } catch (error) {
      console.error(error)
    }
  },
  async [CommonActionType.FETCH_ORDER_DELIVERY_STATUS_LIST_IT] ({ commit }: any, { language }: any) {
    try {
      const response = await getOrderDeliveryStatusITAPI()
      commit(CommonMutationType.SET_ORDER_DELIVERY_STATUS_LIST_IT, response[language])
    } catch (error) {
      console.error(error)
    }
  }
}

const mutations: MutationTree<ICommonState> & ICommonMutations = {
  [CommonMutationType.SET_ORDER_REVIEW] (state, payload) {
    state.orderReview = payload
  },
  [CommonMutationType.SET_ORDER_STATUS_CZ] (state, payload) {
    state.orderStatusCZ = payload
  },
  [CommonMutationType.SET_SHIPMENT_PLACES_LIST] (state, payload) {
    state.shipmentPlacesList = payload
  },
  [CommonMutationType.SET_ORDER_TRANSPORT_TYPES_LIST] (state, payload) {
    state.orderTransportTypesList = payload
  },
  [CommonMutationType.SET_ORDER_STATUS_LIST] (state, payload) {
    state.orderStatusList = payload
  },
  [CommonMutationType.SET_ORDER_STATUS_LIST_IT] (state, payload) {
    state.orderStatusListIT = payload
  },
  [CommonMutationType.SET_ORDER_DELIVERY_STATUS_LIST_IT] (state, payload) {
    state.orderDeliveryStatusListIT = payload
  },
  [CommonMutationType.INCREMENT_LOADING] (state: ICommonState) {
    state.loadingCount++
  },
  [CommonMutationType.DECREMENT_LOADING] (state: ICommonState) {
    if (state.loadingCount > 0) {
      state.loadingCount--
    }
  },
  [CommonMutationType.ADD_MULTIPLE_CUSTOMER] (state: ICommonState) {
    state.multipleTypeCustomer = true
  },
  [CommonMutationType.REMOVE_MULTIPLE_CUSTOMER] (state: ICommonState) {
    state.multipleTypeCustomer = false
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
